export enum FeatureEnrollmentPageViewKind {
  Loading = "loading",
  Ready = "ready",
  AlreadyEnrolled = "already-enrolled",
  Expired = "expired",
  Disabled = "disabled",
  NotFound = "not-found",
  Error = "error",
}
